import type { FeatureTriggerTuning } from "@slot/game-shell";
import type { PanelMotionTuning } from "../views/PanelMotion";

/**
 * Per-game FEATURE-TRIGGER ("feature enter") panel tuning VALUES — the ONLY file to edit to retune it. The shell's part
 * (`FeatureTriggerTuning`: the arm delay, the music) is passed whole into the shell's presenter (wired in
 * createPresentation); the view's motion is `anim` (`PanelMotionTuning`, the title's own since decision 40 #21).
 */
export const FEATURE_TRIGGER_TUNING: FeatureTriggerTuning & { anim: PanelMotionTuning } = {
  armDelayMs: 800,
  music: {
    // The main theme KEEPS playing under the panel: the idle id is the base loop, so the panel's switch is a same-id
    // no-op; on dismiss the music crossfades to the feature's loop.
    idleId: "music_base",
    idleFadeInDelayMs: 400,
    idleFadeMs: 1500,
    loopId: "music_feature_free_spins",
    // VS Rush runs on its own loop; Super Bonus (and a natural trigger) on the default.
    loopIdByFeatureId: { vs_rush_buy: "music_feature_free_spins_2" },
    loopFadeMs: 1500,
  },
  anim: {
    // The panel only FADES: its enter / exit scale and its idle pulse are pinned to 1 (the Cocos title disabled them).
    // It has no title node of its own, so the title pulse has nothing to move.
    enterScaleFrom: 1,
    enterDurationSeconds: 0.35,
    exitScaleTo: 1,
    exitDurationSeconds: 0.25,
    continueFadeInSeconds: 0.4,
    continueFadeOutSeconds: 0.2,
    loopPanelScaleMax: 1,
    loopPanelHalfSeconds: 1.2,
    loopTitleScaleMax: 1.05,
    loopTitleHalfSeconds: 0.7,
  },
};
